import React from 'react'

const Welcome = () => {
    return (
        <div className='grid h-screen place-items-center'>
            <div class="text-center min-h-[140px] w-full place-items-center overflow-hidden rounded-lg p-6 lg:overflow-visible">
                <div class="w-full md:w-7/12 pt-5 px-4 mb-8 mx-auto text-center">
                <div className='text-2xl text-gray-800'>
                    <h2>webDoc</h2>
                </div>
                    <div class="text-xl text-gray-700 py-1">
                        <h3>Chat with the  patients....</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Welcome
